import { selectCanvasSubgraphV3, pasteCanvasSubgraphV3, type CanvasClipboardV3 as CanvasClipboard, type CanvasDocumentV3 as CanvasDocument, type Point } from "@seedance/contracts";
export type { CanvasClipboard };
export function copyCanvasSelection(document: CanvasDocument, ids: readonly string[]): CanvasClipboard {
  return selectCanvasSubgraphV3(document, ids);
}
export function pasteCanvasSelection(document: CanvasDocument, clipboard: CanvasClipboard, anchor: Point): CanvasDocument {
  return pasteCanvasSubgraphV3(document, clipboard, anchor, () => crypto.randomUUID()).document;
}
